import EligibilityChecker from './compositions/EligibilityChecker';

function App() {
    return <EligibilityChecker />;
}

export default App;
